import { BrowserModule } from '@angular/platform-browser';
import { NgModule, enableProdMode } from '@angular/core';

import {DatePipe} from '@angular/common';

// import { AppRoutingModule } from './app-routing.module';
import { AppRoutingModule } from './shared/routing/app-routing.module';


import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AngularFontAwesomeModule } from 'angular-font-awesome';

import { FlexLayoutModule } from '@angular/flex-layout';

import { QRCodeModule } from 'angularx-qrcode';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { HttpClientModule } from '@angular/common/http';
import { MatBadgeModule, MatMenuModule, MatTabsModule, MatExpansionModule, MatTooltipModule, MatChipsModule, MatSnackBarModule, MatCardModule, MatIconModule, MatTableModule, MatSortModule, MatPaginatorModule, MatInputModule, MatAutocompleteModule, MatButtonModule, MatRadioModule, MatDialogModule, MatDatepickerModule, MatNativeDateModule, MatSelectModule, MatCheckboxModule, MatListModule, MatProgressBarModule, MatGridListModule, MatStepperModule, MatSidenavModule, MatToolbarModule, MatBottomSheetModule, MatButtonToggleModule} from '@angular/material';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { MatTableExporterModule } from 'mat-table-exporter';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import {NgxPrintModule} from 'ngx-print';
import { HomeComponent } from './home/home.component';
import { GroupByPipe } from 'src/assets/shared/sharedpipes/group-by.pipe';
import { NumberToWordsPipe } from 'src/assets/shared/sharedpipes/number-to-words.pipe';

import {NgPipesModule} from 'ngx-pipes';
import { AvatarModule } from 'ngx-avatar';
import { ProductdescriptionService } from 'src/assets/services/productdescription.service';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SortPipe } from 'src/assets/shared/sharedpipes/sort.pipe';
import { filterproduct } from 'src/assets/shared/sharedpipes/filterproduct.pipe';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
// Auth service
import { AuthService } from "./shared/services/auth.service";
import { OverlayModule } from '@angular/cdk/overlay';
import { HeaderComponent } from './header/header.component';
import { NgxStarsModule } from 'ngx-stars';
import { IndianCurrency } from 'src/assets/shared/sharedpipes/indianCurrency.pipe';
import { DateSuffixPipe } from 'src/assets/shared/sharedpipes/datesuffix.pipe';
import { CenterMatmenuDirective } from './header/center-matmenu.directive';
import { NgxSlickJsModule } from "ngx-slickjs";
import { DateAgoPipe } from 'src/assets/shared/sharedpipes/date-ago.pipe';
import { FooterComponent } from './footer/footer.component';
import { FooterminiComponent } from './footermini/footermini.component';
import { Globals } from 'src/assets/shared/globals';
import { WindowService } from './components/sign-up/window.service';

import { NgxImageDisplayModule } from '@creativeacer/ngx-image-display';
import { LabelsComponent } from './labels/Labels.component';
import { filteruniquecode } from 'src/assets/shared/sharedpipes/filteruniquecode.pipe';
import { Labels2Component } from './labels2/labels2.component';


var config = {
  apiKey: "AIzaSyAka7u5Pc8UkVW40988PSrDtWm6fSZRt4Y",
  authDomain: "crescenttraderswebapp.firebaseapp.com",
  projectId: "crescenttraderswebapp",
  storageBucket: "crescenttraderswebapp.appspot.com",
  messagingSenderId: "792724513569",
  appId: "1:792724513569:web:55cddf96e1ba5bd51d9460",
  measurementId: "G-JFT4RH2PMQ"
};

enableProdMode();

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    FlexLayoutModule,
    QRCodeModule,
    AngularFontAwesomeModule,
    OverlayModule,
    NgxSlickJsModule.forRoot({
      links: {
        jquery: "https://code.jquery.com/jquery-3.4.0.min.js",
        slickJs:
          "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js",
        slickCss:
          "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css",
        slickThemeCss: null // if you are set null, this css won't load
      }
    }),
    MatStepperModule,
    MatSidenavModule,
    MatToolbarModule,
    MatBadgeModule,
    MatMenuModule,
    MatTabsModule,
    MatExpansionModule,
    MatTooltipModule,
    MatChipsModule,
    MatSnackBarModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatRadioModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDialogModule, 
    MatBottomSheetModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCheckboxModule,
    MatListModule,
    MatProgressBarModule,
    MatGridListModule,
    MatCarouselModule.forRoot(),
    MatTableExporterModule,
    MatProgressSpinnerModule,
    NgxPaginationModule,
    NgxPrintModule,
    FormsModule,
    NgxDaterangepickerMd.forRoot(),
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxImageDisplayModule.forRoot(),
    AngularFireModule.initializeApp(config),
    AngularFirestoreModule, // firestore
    AngularFireDatabaseModule, //database
    AngularFireAuthModule, // auth
    AngularFireStorageModule, // storage
    NgPipesModule,
    AvatarModule,
    LazyLoadImageModule,
    NgxStarsModule
    ],
  providers: [WindowService,Globals,AuthService,MatDatepickerModule,DatePipe,ProductdescriptionService],
  entryComponents: [HeaderComponent],
  declarations: [ DateAgoPipe, DateSuffixPipe,IndianCurrency, filterproduct,filteruniquecode, SortPipe, NumberToWordsPipe, GroupByPipe, AppComponent, HomeComponent, SignInComponent, SignUpComponent, ForgotPasswordComponent, VerifyEmailComponent, HeaderComponent, CenterMatmenuDirective, FooterComponent, FooterminiComponent, LabelsComponent, Labels2Component],
  bootstrap: [AppComponent]
})
export class AppModule { }

